<template>
  <div class="circle">
    <p class="circle__text">
      <span class="circle__text-top">91%</span>
      <span
        class="circle__text-bottom "
        v-html="$t('Respondents_found_IES3_to_be_pleasant_and_quiet')"
      ></span>
    </p>
  </div>
</template>

<script>
export default {
  name: "GreenInformatinoCircle"
};
</script>

<style scoped>
.circle {
  width: 24vw;
  height: 24vw;
  position: absolute;
  bottom: -6%;
  right: -2%;
  background-color: #59ae9b;
  border-radius: 50%;
  display: flex;
  max-width: 300px;
  max-height: 300px;
  justify-content: center;
  align-items: center;
  box-shadow: 18px 10px 15px 1px rgba(0, 0, 0, 0.33);
}
.circle__text {
  display: flex;
  text-align: center;
  font-family: "Netto Black", "Open Sans", sans-serif;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
@media (max-width: 575.98px) {
  .circle {
    width: 32vw;
    height: 32vw;
    bottom: 0%;
  }
  .circle__text {
    font-size: 0.6rem;
    line-height: 0.7rem;
    padding: 0 0.5rem;
  }
  .circle__text-top {
    font-size: 1rem;
    line-height: 1.4rem;
  }
}
@media (min-width: 360px) and (max-width: 575.98px) {
  .circle {
    width: 28vw;
    height: 28vw;
    bottom: 0%;
  }
  .circle__text {
    font-size: 0.6rem;
    line-height: 0.7rem;
    padding: 0 0.5rem;
  }
  .circle__text-top {
    font-size: 1.3rem;
    line-height: 1.4rem;
  }
}
@media (max-width: 767.98px) and (min-width: 576px) {
  .circle__text {
    padding: 0 1rem;
    font-size: 0.8rem;
    line-height: 1rem;
  }
  .circle__text-top {
    padding: 0 1.5rem;
    font-size: 1.9rem;
    line-height: 2.1rem;
    margin-top: -0.2rem;
  }
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .circle__text {
    padding: 0 2rem;
    font-size: 1rem;
    line-height: 1.2rem;
  }
  .circle__text-top {
    font-size: 2.4rem;
    line-height: 2.6rem;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .circle__text {
    padding: 0 2rem;
    font-size: 1.3rem;
    line-height: 1.2rem;
  }
  .circle__text-top {
    font-size: 2.7rem;
    line-height: 2.6rem;
  }
}
@media (min-width: 1199.98px) {
  .circle__text {
    padding: 0 2rem;
    font-size: 1.5rem;
    line-height: 1.4rem;
  }
  .circle__text-top {
    font-size: 3rem;
    line-height: 2.9rem;
  }
}
</style>
